module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 gutr"
  }, [_c('div', {
    staticClass: "box-body gutr"
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": "warning"
    }
  }, [_vm._v("Additional Task Request")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-sm gutr",
    attrs: {
      "id": "otherAdditionalTask"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.otherAdditionalTask_Data), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.AMTSeries))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ledger))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.scCategory))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.selling_amt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.remark))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.loginTime))])])
  }), _vm._v(" "), (_vm.otherAdditionalTask_Data.length <= 0) ? _c('tr', [_vm._m(1)]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body gutr"
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Sline Payment Details")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-sm gutr",
    attrs: {
      "id": "otherAdditionalTask"
    }
  }, [_c('tbody', [_vm._m(2), _vm._v(" "), _vm._l((_vm.SlinePayment_Data), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [(item.SlineUpload) ? _c('a', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.openSignedDocument(("ASSIGNMENT_UPLOADS/" + (_vm.PMS_jb_series.replaceAll('/', '_')) + "/" + (item.SlineUpload.replaceAll('/', '_'))))
        }
      }
    }, [_c('b', [_c('u', [_vm._v(_vm._s(item.SlineInvNo))])])]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.SlineInvCategory))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.newSlineInvType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.SlineInvAmount))]), _vm._v(" "), _c('td', [(item.SlineInvPayMode == 1) ? _c('span', [_vm._v("RTGS")]) : (item.SlineInvPayMode == 2) ? _c('span', [_vm._v("Cheque")]) : _c('span')]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.SlineInvPayRef))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.SlineInvPaidAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.SlineInvPayDate))]), _vm._v(" "), _c('td', [(item.SlineInvPayStatus == 1) ? _c('span', [_vm._v("Partial")]) : (item.SlineInvPayStatus == 2) ? _c('span', [_vm._v("Completed")]) : _c('span', [_vm._v("Pending")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.scCategory))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.scremark))])])
  }), _vm._v(" "), (_vm.SlinePayment_Data.length <= 0) ? _c('tr', [_vm._m(3)]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body gutr"
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Expense Document Details")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-sm gutr",
    attrs: {
      "id": "otherAdditionalTask"
    }
  }, [_c('tbody', [_vm._m(4), _vm._v(" "), _vm._l((_vm.ExpenseDoc_Data), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.expenseDate))]), _vm._v(" "), _c('td', [(item.documentLink) ? _c('a', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.openSignedDocument(("ASSIGNMENT_UPLOADS/" + (_vm.PMS_jb_series.replaceAll('/', '_')) + "/" + (item.documentLink.replaceAll('/', '_'))))
        }
      }
    }, [_c('b', [_c('u', [_vm._v(_vm._s(item.otherDocName))])])]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.docRemarks))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.doc_added_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.employeeName))])])
  }), _vm._v(" "), (_vm.ExpenseDoc_Data.length <= 0) ? _c('tr', [_vm._m(5)]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body gutr"
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Expense Charges Details")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-sm gutr",
    attrs: {
      "id": "otherTallyExpCharges"
    }
  }, [_c('tbody', [_vm._m(6), _vm._v(" "), _vm._l((_vm.otherTallyExpCharges), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('b-button', {
      staticClass: "mt-1",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "variant": "outline-info",
        "size": "xs"
      },
      on: {
        "click": function($event) {
          _vm.showExpenseDet(item)
        }
      }
    }, [_vm._v(_vm._s(item.docDtls_No))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.docDtls_Typ))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Exp_Date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vendorName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vendorGST))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.AMT))]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(parseFloat(item.CGST) +
      parseFloat(item.SGST) +
      parseFloat(item.IGST) +
      parseFloat(item.CesVal) +
      parseFloat(item.StCesVal) +
      parseFloat(item.OthChrg) +
      parseFloat(item.RndOffAmt) -
      parseFloat(item.Discount)) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.TotInvVal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ExpContainersNo))])])
  }), _vm._v(" "), (_vm.otherTallyExpCharges.length <= 0) ? _c('tr', [_vm._m(7)]) : _vm._e()], 2)])]), _vm._v(" "), (_vm.all_module_id) ? _c('OldExpenseAdditionalTask', {
    attrs: {
      "allModuleId": _vm.all_module_id,
      "type": "additional-task"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "otherTallyExpCharges-modal",
    attrs: {
      "id": "otherTallyExpCharges-modal",
      "title": _vm.modal_title + _vm.modal_JobNo,
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "tpt"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN.")]), _vm._v(" "), _c('th', [_vm._v("Particulars")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th', [_vm._v("Barcode")]), _vm._v(" "), _c('th', [_vm._v("HSNCode")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("GST Rate")]), _vm._v(" "), _c('th', [_vm._v("IGST Amt")]), _vm._v(" "), _c('th', [_vm._v("CGST Amt")]), _vm._v(" "), _c('th', [_vm._v("SGST Amt")]), _vm._v(" "), _c('th', [_vm._v("Cest Rt/Amt")]), _vm._v(" "), _c('th', [_vm._v("Amt")]), _vm._v(" "), _c('th', [_vm._v("Total")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ExpenseItemDeatils), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.prdDesc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.barcde))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.hsnCd))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(item1.totAmt) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.gstRt))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(item1.igstAmt) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.cgstAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.sgstAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.cesRt) + " / " + _vm._s(item1.cesAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.assAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.totItemVal) + " " + _vm._s(item1.orgCntry))])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Amount + Tax = Total Amount ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.singleItem.AMT) + " + " + _vm._s(_vm.taxAmount) + " =\n              " + _vm._s(_vm.singleItem.TotInvVal) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('center', [_c('b-button', {
    staticClass: "mt-1",
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": _vm.hideExpenseDet
    }
  }, [_vm._v("\n              Close")])], 1)], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "aquamarine",
      "color": "black"
    }
  }, [_c('tr', [_c('th', [_vm._v("SN")]), _vm._v(" "), _c('th', [_vm._v("Task No.")]), _vm._v(" "), _c('th', [_vm._v("Expense")]), _vm._v(" "), _c('th', [_vm._v("Exp Amount")]), _vm._v(" "), _c('th', [_vm._v("Bill to Customer")]), _vm._v(" "), _c('th', [_vm._v("Selling Amount")]), _vm._v(" "), _c('th', [_vm._v("Remark")]), _vm._v(" "), _c('th', [_vm._v("Added on")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "text-align": "center",
      "color": "red"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('b', [_vm._v("NO Additional Task Request ADDED")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("SN")]), _vm._v(" "), _c('th', [_vm._v("Invoice No")]), _vm._v(" "), _c('th', [_vm._v("Invoice Category")]), _vm._v(" "), _c('th', [_vm._v("Invoice Type")]), _vm._v(" "), _c('th', [_vm._v("Invoice Amount")]), _vm._v(" "), _c('th', [_vm._v("Payment Mode")]), _vm._v(" "), _c('th', [_vm._v("Payment Refrence No.")]), _vm._v(" "), _c('th', [_vm._v("Payment Amount")]), _vm._v(" "), _c('th', [_vm._v("Payment Date")]), _vm._v(" "), _c('th', [_vm._v("Payment Status")]), _vm._v(" "), _c('th', [_vm._v("Bill to Shipper")]), _vm._v(" "), _c('th', [_vm._v("Bill to Shipper Remark")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "text-align": "center",
      "color": "red"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_c('b', [_vm._v("NO Sline Payment Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("SN")]), _vm._v(" "), _c('th', [_vm._v("Expense Date")]), _vm._v(" "), _c('th', [_vm._v("View")]), _vm._v(" "), _c('th', [_vm._v("Remark")]), _vm._v(" "), _c('th', [_vm._v("Doc. Adding Time")]), _vm._v(" "), _c('th', [_vm._v("Doc. Added By")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "text-align": "center",
      "color": "red"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("NO Expense Document ADDED")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("SN")]), _vm._v(" "), _c('th', [_vm._v("Exp No")]), _vm._v(" "), _c('th', [_vm._v("Exp Type")]), _vm._v(" "), _c('th', [_vm._v("Exp Date")]), _vm._v(" "), _c('th', [_vm._v("Vendor Name")]), _vm._v(" "), _c('th', [_vm._v("Vendor GST")]), _vm._v(" "), _c('th', [_vm._v("AMT")]), _vm._v(" "), _c('th', [_vm._v("GST AMT")]), _vm._v(" "), _c('th', [_vm._v("TOT AMT")]), _vm._v(" "), _c('th', [_vm._v("Remark")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "text-align": "center",
      "color": "red"
    },
    attrs: {
      "colspan": "10"
    }
  }, [_c('b', [_vm._v("NO Expense Document ADDED")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34d707ba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/paymentSummary.vue
// module id = 2515
// module chunks = 0